/* ==============================================
   BOXD for Him — Theme JavaScript
   Cart drawer, mobile menu, accordions, card selector
============================================== */

(function() {
  'use strict';

  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  // ─────── MOBILE MENU ───────
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const menuClose = document.querySelector('[data-menu-close]');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      mobileMenu.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (menuClose && mobileMenu) {
    menuClose.addEventListener('click', () => {
      mobileMenu.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  // ─────── CART DRAWER ───────
  const cartTriggers = document.querySelectorAll('[data-cart-trigger]');
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartOverlay = document.querySelector('[data-cart-overlay]');
  const cartClose = document.querySelector('[data-cart-close]');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  cartTriggers.forEach(t => t.addEventListener('click', e => {
    e.preventDefault();
    openCart();
  }));
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // Esc closes cart
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeCart();
  });

  // ─────── ADD TO CART (AJAX) ───────
  document.addEventListener('submit', async (e) => {
    if (!e.target.matches('.js-product-form')) return;
    e.preventDefault();
    const form = e.target;
    const button = form.querySelector('[type="submit"]');
    const originalText = button ? button.textContent : '';
    if (button) {
      button.textContent = 'ADDING...';
      button.disabled = true;
    }

    try {
      const formData = new FormData(form);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      });
      if (!res.ok) throw new Error('Add to cart failed');
      await res.json();
      await refreshCart();
      openCart();
      if (button) {
        button.textContent = 'ADDED ✓';
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 1200);
      }
    } catch (err) {
      console.error('Cart error:', err);
      if (button) {
        button.textContent = 'ERROR — TRY AGAIN';
        button.disabled = false;
      }
    }
  });

  // ─────── CART REFRESH ───────
  async function refreshCart() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      renderCart(cart);
      updateCartCount(cart.item_count);
    } catch (err) {
      console.error('Cart refresh error:', err);
    }
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.setAttribute('data-count', count);
      el.textContent = count;
    });
  }

  function renderCart(cart) {
    const itemsContainer = document.querySelector('[data-cart-items]');
    const totalsContainer = document.querySelector('[data-cart-total]');
    const shippingBar = document.querySelector('[data-shipping-bar]');
    const shippingText = document.querySelector('[data-shipping-text]');
    const shippingProgress = document.querySelector('[data-shipping-progress]');

    if (!itemsContainer) return;

    if (cart.item_count === 0) {
      itemsContainer.innerHTML = '<div class="cart-empty">Your cart is waiting.</div>';
      if (totalsContainer) totalsContainer.textContent = '$0';
      if (shippingBar) shippingBar.style.display = 'none';
      return;
    }

    if (shippingBar) shippingBar.style.display = '';

    // Cart items
    itemsContainer.innerHTML = cart.items.map(item => {
      const cardChoice = (item.properties && item.properties._card)
        || (item.properties && item.properties.Card)
        || '';
      const cardLine = cardChoice ? `<div class="cart-item-meta">Card: ${escapeHtml(cardChoice)}</div>` : '';
      const imgSrc = item.image || '';
      return `
        <div class="cart-item">
          <div class="cart-item-image" style="background-image: url('${imgSrc}')"></div>
          <div>
            <div class="cart-item-name">${escapeHtml(item.product_title)}</div>
            ${cardLine}
            <div class="cart-item-price">${formatMoney(item.final_line_price)}</div>
            <button class="cart-item-remove" data-cart-remove="${item.key}">REMOVE</button>
          </div>
        </div>
      `;
    }).join('');

    // Total
    if (totalsContainer) totalsContainer.textContent = formatMoney(cart.total_price);

    // Shipping bar — Free over $100 (10000 cents)
    const threshold = 10000;
    const total = cart.total_price;
    if (shippingText && shippingProgress) {
      if (total >= threshold) {
        shippingText.innerHTML = '<strong>You\'ve unlocked free shipping ✓</strong>';
        shippingProgress.style.width = '100%';
      } else {
        const remaining = threshold - total;
        const pct = Math.round((total / threshold) * 100);
        shippingText.innerHTML = `Free shipping at $100 — <strong>add ${formatMoney(remaining)}</strong>`;
        shippingProgress.style.width = pct + '%';
      }
    }
  }

  // Remove item
  document.addEventListener('click', async (e) => {
    if (!e.target.matches('[data-cart-remove]')) return;
    const key = e.target.getAttribute('data-cart-remove');
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      if (!res.ok) throw new Error('Remove failed');
      await refreshCart();
    } catch (err) {
      console.error('Remove error:', err);
    }
  });

  // ─────── HELPERS ───────
  function escapeHtml(str) {
    if (typeof str !== 'string') return '';
    return str.replace(/[&<>"']/g, m => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[m]));
  }
  function formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return '$' + dollars;
  }

  // ─────── CARD SELECTOR ───────
  document.querySelectorAll('[data-card-options]').forEach(group => {
    const options = group.querySelectorAll('[data-card-option]');
    const hidden = group.parentElement.querySelector('[data-card-input]');
    options.forEach(opt => {
      opt.addEventListener('click', () => {
        options.forEach(o => o.classList.remove('is-selected'));
        opt.classList.add('is-selected');
        if (hidden) hidden.value = opt.getAttribute('data-card-value') || '';
      });
    });
  });

  // ─────── FAQ ACCORDIONS ───────
  document.querySelectorAll('[data-faq-question]').forEach(q => {
    q.addEventListener('click', () => {
      const item = q.closest('[data-faq-item]');
      if (item) item.classList.toggle('is-open');
    });
  });

  // ─────── PRODUCT GALLERY ───────
  document.querySelectorAll('[data-gallery-thumb]').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const url = thumb.getAttribute('data-image');
      const main = document.querySelector('[data-gallery-main]');
      if (main && url) main.style.backgroundImage = `url('${url}')`;
      document.querySelectorAll('[data-gallery-thumb]').forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  // ─────── INITIAL CART REFRESH ───────
  refreshCart();

  // ─────── EMAIL CAPTURE FORM ───────
  document.querySelectorAll('.js-email-form').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const button = form.querySelector('button');
      const original = button ? button.textContent : '';
      if (button) { button.textContent = 'JOINING...'; button.disabled = true; }

      try {
        const formData = new FormData(form);
        const res = await fetch('/contact#contact_form', {
          method: 'POST',
          body: formData
        });
        if (button) {
          button.textContent = 'THANK YOU ✓';
          setTimeout(() => { button.textContent = original; button.disabled = false; form.reset(); }, 2500);
        }
      } catch (err) {
        if (button) { button.textContent = 'TRY AGAIN'; button.disabled = false; }
      }
    });
  });

})();

// ─────── STICKY ATC ───────
(function() {
  const stickyBar = document.getElementById('sticky-atc');
  const stickyBtn = document.getElementById('sticky-atc-btn');
  const mainAtc = document.querySelector('.product-atc');

  if (!stickyBar || !mainAtc) return;

  // Show sticky bar after main ATC scrolls out of view
  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        stickyBar.classList.remove('is-visible');
        stickyBar.setAttribute('aria-hidden', 'true');
      } else {
        stickyBar.classList.add('is-visible');
        stickyBar.setAttribute('aria-hidden', 'false');
      }
    });
  }, { threshold: 0 });

  observer.observe(mainAtc);

  // Sticky ATC button triggers the main form
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function() {
      const form = document.querySelector('.js-product-form');
      if (form) {
        const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
        form.dispatchEvent(submitEvent);
      }
    });
  }
})();

// ─────── CLOSE MOBILE MENU ON LINK CLICK ───────
document.querySelectorAll('[data-mobile-menu] a').forEach(function(link) {
  link.addEventListener('click', function() {
    var menu = document.querySelector('[data-mobile-menu]');
    if (menu) menu.classList.remove('is-open');
    document.body.style.overflow = '';
  });
});

// ─────── ACTIVE NAV LINK ───────
(function() {
  var path = window.location.pathname;
  document.querySelectorAll('.nav-link, .mobile-menu-link').forEach(function(link) {
    if (link.getAttribute('href') === path) {
      link.style.color = 'var(--gold)';
    }
  });
})();
